import moldData from "./register/reducer"
import transferMoldData from "./transfer/reducer"
import physicalcount from "./physicalcount/reducer"

const formworkMangement = { moldData, transferMoldData, physicalcount }

export default formworkMangement